import React from 'react';
import { Button } from 'antd';
import Icon from '@ant-design/icons';
import { ArrowRightSvg } from '@/assets/svg';

interface ParameterCounterProps {
	value: number;
	onClick?: () => void;
	disabled?: boolean;
	showArrow?: boolean;
}

const ParameterCounter: React.FC<ParameterCounterProps> = ({
	value,
	onClick,
	disabled = false,
	showArrow = false,
}) => {
	if (!onClick || disabled) {
		return <span>{value}</span>;
	}

	return (
		<div className="w-full flex justify-between px-2 items-center">
			<Button 
				color="default" 
				variant="text" 
				size="small" 
				className="!px-0 !min-w-0"
				onClick={onClick}
			>
				<span className="text-[#078CB3] font-bold underline">{value}</span>
			</Button>

			{showArrow && (
				<Button 
					color="default" 
					variant="text" 
					size="small" 
					className="!px-0 !min-w-0"
				onClick={onClick}
			>
				<Icon component={ArrowRightSvg} className="text-[#078CB3]" />
			</Button>
			)}
		</div>
	);
};

export default ParameterCounter;